import { __extends, __makeTemplateObject } from "tslib";
import React, { Component } from 'react';
import { css } from 'styled-components';
import { createComponent } from '../utils';
var TabsProvider = createComponent({
    name: 'Tabs',
    style: function (_a) {
        var vertical = _a.vertical;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: ", ";\n  "], ["\n    display: flex;\n    flex-direction: ", ";\n  "])), vertical ? 'row' : 'column');
    },
});
var TabList = createComponent({
    name: 'TabList',
    tag: 'ul',
    style: function (_a) {
        var vertical = _a.vertical, theme = _a.theme;
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    flex-direction: ", ";\n\n    ", ";\n  "], ["\n    display: flex;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    flex-direction: ", ";\n\n    ",
            ";\n  "])), vertical ? 'column' : 'row', !vertical && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n    "], ["\n      border-bottom: 1px solid ", ";\n    "])), theme.colors.greyLighter));
    },
});
var TabListItem = createComponent({
    name: 'TabListItem',
    tag: 'li',
    style: function () { return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    margin: 0;\n    padding: 0;\n  "], ["\n    display: flex;\n    margin: 0;\n    padding: 0;\n  "]))); },
});
var Tab = createComponent({
    name: 'Tab',
    tag: 'button',
    style: function (_a) {
        var vertical = _a.vertical, disabled = _a.disabled;
        return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    appearance: none;\n    margin: 0;\n    padding: 0;\n    background: none;\n    border: none;\n    font-size: 14px;\n    font-family: inherit;\n    position: relative;\n    justify-content: center;\n    cursor: pointer;\n    margin-", ": 1px;\n    margin-", ": -1px;\n    padding: ", ";\n    outline: none;\n    white-space: nowrap;\n    opacity: ", ";\n\n    &:active {\n      outline: none;\n    }\n  "], ["\n    appearance: none;\n    margin: 0;\n    padding: 0;\n    background: none;\n    border: none;\n    font-size: 14px;\n    font-family: inherit;\n    position: relative;\n    justify-content: center;\n    cursor: pointer;\n    margin-", ": 1px;\n    margin-", ": -1px;\n    padding: ", ";\n    outline: none;\n    white-space: nowrap;\n    opacity: ", ";\n\n    &:active {\n      outline: none;\n    }\n  "])), vertical ? 'left' : 'top', vertical ? 'right' : 'bottom', vertical ? '0' : '0 12px', disabled ? 0.5 : 1);
    },
});
var TabTitle = createComponent({
    name: 'TabTitle',
    tag: 'span',
    style: function (_a) {
        var active = _a.active, vertical = _a.vertical, theme = _a.theme;
        return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: block;\n    color: ", ";\n    padding: ", ";\n    border-", ": 4px solid ", ";\n\n    &::hover {\n      color: #212b36;\n      border-color: ", ";\n    }\n  "], ["\n    display: block;\n    color: ", ";\n    padding: ", ";\n    border-", ": 4px solid ", ";\n\n    &::hover {\n      color: #212b36;\n      border-color: ", ";\n    }\n  "])), active ? theme.colors.greyDarkest : theme.colors.greyDark, vertical ? '8px 12px 8px 8px' : '12px 8px', vertical ? 'left' : 'bottom', active ? theme.colors.primary : 'transparent', active ? theme.colors.primary : theme.colors.greyLight);
    },
});
var TabContent = createComponent({
    name: 'TabContent',
    tag: 'div',
    style: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "]))),
});
var Tabs = (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: _this.props.active || 0,
        };
        _this.handleTabClick = function (selected) {
            if (_this.props.onChange) {
                _this.props.onChange(selected);
            }
            _this.setState({
                active: selected,
            });
        };
        return _this;
    }
    Tabs.prototype.componentDidUpdate = function () {
        if (this.props.active && this.props.active !== this.state.active) {
            this.setState({
                active: this.props.active,
            });
        }
    };
    Tabs.prototype.renderHeadings = function () {
        var _this = this;
        return this.props.tabs.map(function (tab, i) {
            var id = tab.id || i;
            return (React.createElement(TabListItem, { key: id },
                React.createElement(Tab, { id: id, disabled: tab.disabled, vertical: _this.props.vertical, onClick: function () {
                        if (tab.onActive) {
                            tab.onActive();
                        }
                        _this.handleTabClick(i);
                    } },
                    React.createElement(TabTitle, { active: _this.state.active === i, vertical: _this.props.vertical }, tab.title))));
        });
    };
    Tabs.prototype.renderContent = function () {
        var content = this.props.tabs[this.state.active].content;
        if (React.isValidElement(content)) {
            return content;
        }
        throw new Error('Tab content must be a valid React element.');
    };
    Tabs.prototype.render = function () {
        return (React.createElement(TabsProvider, { vertical: this.props.vertical },
            React.createElement(TabList, { vertical: this.props.vertical }, this.renderHeadings()),
            React.createElement(TabContent, null, this.renderContent())));
    };
    Tabs.defaultProps = {
        vertical: false,
    };
    return Tabs;
}(Component));
export default Tabs;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Tabs.js.map